/* Shadow style module */

import color from '../../color';

const shadowColor = color.grayXS;

const shadow = {
  std: {
    boxShadow: `0 10px 20px -10px ${shadowColor}`,
  },
  vertical: {
    boxShadow: `0px 5px 10px ${shadowColor}`,
  },
  popover: {
    boxShadow: `1px 1px 5px ${shadowColor}`,
  },
  left: {
    boxShadow: `-2px 0 5px ${shadowColor}`,
  },
  right: {
    boxShadow: `2px 0 5px ${shadowColor}`,
  },
  emphasis: {
    boxShadow: `0 5px 20px 2px ${shadowColor}`,
  },
  none: {
    boxShadow: 'none',
  },
};

export default shadow;
